import { AxiosResponse } from 'axios'
import { request } from './request'
import JSEncrypt from 'jsencrypt'
const encrypt = new JSEncrypt()
encrypt.setPublicKey(`-----BEGIN  WUMAN  RSA PUBLIC KEY -----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzmV1UAmMxf2iTz+Ynqzr
dlLe9fLAxb+eHBPGUNcey4wBl0NpBnqqRkT7jtZbR8DP/8lEINglsxinkc6VkPYQ
jwJ84iOP6UJI9I51x/Da5mzscWOLexZrCTB891JAWAuygEzoHby2WyH98Mk9jtKm
4gv8hKtvx3n+YO5rv5M+eaYoBco4hh7VSqi6uN+IlIn6kVRQYe0tPDaKNLf1YFJC
W7V0c0BWaIr7KhSKfwpyx4touPrvgFqnTEx5nyyhXrn2OwNYeq3DO3679qt25Pb7
o/4vjlGoTQOI6Hdb5MB2Kh/46p272KGIwR3G2JDbgX+G/qFFLYzOtE9LBg6vxxip
mQIDAQAB
-----END  WUMAN  RSA PUBLIC KEY -----`)
// 登录
export interface LoginData {
  username: string
  password: string
  verify?: string
  verify_token?: string
  email_verify?: string
}
export const login = (data: LoginData): Promise<AxiosResponse<any>> =>
  request('/portal/login', {
    method: 'post',
    data: {
      username: data.username,
      password: encrypt.encrypt(data.password),
      verify: data?.verify,
      verify_token: data.verify_token,
      email_verify: data.email_verify,
    },
  })
// 获取验证码
export interface Verify {
  verify_type: 'login' | 'reset_email'
}
export const verify = (data: Verify) =>
  request('/portal/verify', {
    params: {
      ...data,
    },
  })
// 发送登录邮件验证码
export interface Emailcode {
  username: string
  password: string
  verify: string
}
export const emailCode = (data: Emailcode) =>
  request('/portal/user/login/validation_codes', {
    method: 'post',
    data: {
      username: data.username,
      password: encrypt.encrypt(data.password),
      verify: data.verify,
    },
  })
//发送重置邮件
export interface Email {
  email: string
  verify: string
  id_token: string
  url: string
}
export const email = (data: Email) =>
  request('/portal/user/reset/email', {
    method: 'post',
    data,
  })
//重置密码
export interface Reset {
  email: string
  password: string
  email_token: string
}
export const reset = (data: Reset) =>
  request('/portal/user/reset_by_mail', {
    method: 'put',
    data: {
      email: data.email,
      password: encrypt.encrypt(data.password),
      email_token: data.email_token,
    },
  })
//重新发送邮件
export interface Repeat {
  email: string
}
export const repeat = (data: Repeat) =>
  request('/portal/user/reset/email/repeat', {
    method: 'post',
    data,
  })
//重置密码-个人信息
export interface UserReset {
  old_password: string
  new_password: string
}
export const userReset = (data: UserReset) =>
  request('/portal/user/reset_password', {
    method: 'put',
    data: {
      old_password: encrypt.encrypt(data.old_password),
      new_password: encrypt.encrypt(data.new_password),
    },
  })
//获取
export interface Agreement {
  version?: string
  token: string
  user_id: number
}
export const agreement = (data: Agreement) =>
  request('/portal/agreement', {
    headers: { token: data.token, 'user-id': data.user_id },
    params: {
      version: data.version,
    },
  })
//个人信息

//校验密码
export interface VerifyPassword {
  password: string
}
export const verifyPassword = (data: VerifyPassword) =>
  request(`/portal/user/verify_password`, {
    method: 'post',
    data: {
      password: encrypt.encrypt(data.password),
    },
  })
//获取
export const confirm = () =>
  request('/portal/agreement', {
    method: 'post',
  })
//个人信息
// export const userInfo = () => request('/portal/user/info', {})
export const userInfo = () => {
  const loginType = localStorage.getItem('loginType')
  console.log('loginType-----', loginType)
  if (loginType && loginType === 'sub-account') {
    return request('/portal/user/subuser/info', {})
  } else {
    return request('/portal/user/info', {})
  }
}
export const userSubInfo = () => request('/portal/user/subuser/info')
// 获取菜单
export const getMenuList = () => request('/portal/menuList', {})
// 获取授权时间
export const getAuthTime = () =>
  request('/portal/user/info/auth_time', {
    params: {
      login_auth_type: 1, //1 bas
    },
  })
export const passwordLength = () => request('/portal/passwordLength')
// 获取授权时间
export const getLogo = () => request('/portal/logo')
// 退出登录
export const logout = data => request('/portal/logout', { method: 'post', data })

// 子账号登录
export const subLogin = data =>
  request('/portal/user/subuser/login', {
    method: 'post',
    data: {
      username: data.username,
      // password: encrypt.encrypt(data.password),
      password: data.password,
      verify: data?.verify,
      verify_token: data.verify_token,
    },
  })

//获取授权。。。
export const getAuthStatus = () => request('/portal/auth_status')

export interface ConfirmPwd {
  /**
   * 1:是2否
   */
  is_account?: number
  password?: string
  [property: string]: any
}
export const confirmPassword = (data: VerifyPassword) =>
  request(
    `${
      localStorage.getItem('active') * 1 == 1
        ? `/portal/user/verify_password`
        : `/portal/user/subuser/verify_password`
    }`,
    {
      method: 'post',
      data: {
        password: encrypt.encrypt(data.password),
        is_account: data?.is_account,
        user_id: data?.user_id,
      },
    },
  )

export interface FixPwd {
  /**
   * 是否是主账号，1:是2否
   */
  is_account: number
  password: string
  [property: string]: any
}
//修改密码
export const fixPassword = (data: UserReset) =>
  request(
    `${
      localStorage.getItem('active') * 1 === 1
        ? `/portal/user/reset_password`
        : `/portal/user/subuser/reset_password`
    }  `,
    {
      method: 'put',
      data: {
        old_password: encrypt.encrypt(data.old_password),
        new_password: encrypt.encrypt(data.new_password),
      },
    },
  )
